export default __webpack_public_path__ + "static/media/under.ea8d8c27.jpg";